export type AlarmSuggestionState = {
    loading: boolean;
    success: boolean;
    errorCode: string;  
    alarmId: string;
    deviceId: string;
    suggestionAcceptedDetails: {
        userComments: string;
        userSuggestion: string;
    };
    suggestionRejectedDetails: {
        userComments: string;
        userSuggestion: string;
    };

};
export const initialAlarmSuggestion: AlarmSuggestionState = {
    loading: false,
    success: false,
    errorCode:'',   
    alarmId: '',
    deviceId: '',
    suggestionAcceptedDetails: {
        userComments: '',
        userSuggestion: ''

    },
    suggestionRejectedDetails: {
        userComments: '',
        userSuggestion: ''

    }
};
